/**
 * This is just an importer to compile and minify global scripts
 */

// components
require('./modal.jquery');

// paragraphs
